import { render, staticRenderFns } from "./u-waterfall.vue?vue&type=template&id=07df8d1d&scoped=true&"
import script from "./u-waterfall.vue?vue&type=script&lang=js&"
export * from "./u-waterfall.vue?vue&type=script&lang=js&"
import style0 from "./u-waterfall.vue?vue&type=style&index=0&id=07df8d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df8d1d",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-waterfall/u-waterfall.vue"
export default component.exports